<script setup>

	// import {} from "vue/src/v3/index.js";
	import {computed, ref, onMounted} from "vue";

	const baseUrl = ref(window._assetBaseUrl)
	const providers = computed(() => {
		return [...window._providers].sort((a,b) => a.name.localeCompare(b.name));
	})

	const checkCoverage = (e) => {
		if (dataLayer && e) {
			dataLayer.push({event: 'Providers.Check_Coverage.Click'});
		}
	}

</script>

<template>
	<section class="providers">
		<div class="particles"></div>
		<img class="shapes"
			 :src="`${baseUrl}/assets/main/images/shape-backgrounds/bg-providers-shapes.png`"
			 :srcset="`${baseUrl}/assets/main/images/shape-backgrounds/bg-providers-shapes@2x.png 2x`"
			 alt="">
		<div class="wrapper double-column">
			<div class="section-content">
				<h3>Fibre. <br />Unleashed.</h3>
				<p>Pure Fibre works with the infrastructure already in your area.</p>
				<p>Most Fibre Networks are Open-Access, which means that any Internet Service Provider (ISP), such as us, that has an agreement with them can provide you with an Internet connection. As an example, you might currently have Fibre through 'Green Internet', which is just one of the ISPs available on the Vumatel, Openserve or MetroFibre etc. network. Switching from them to us is easy, simple and quick!</p>
				<a href="#" class="btn" v-scroll-to="'header'" @click="checkCoverage"><span>Check Coverage In Your Area</span></a>
			</div><!-- end.section-content -->
			<div class="provider-logos">
				<template v-for="p in providers">
					<a :href="`${baseUrl}provider/${p.slug}`" class="provider-logo" :aria-label="p.name">
						<svg><use :href="`#provider-${p.slug}`"></use></svg>
					</a>
				</template>
			</div><!-- end.provider-logos -->
		</div><!-- end.wrapper -->
	</section><!-- end.providers -->

</template>
